'use client'

import { useBeaconEvents } from './useBeaconEvents'
import { ProctoringEventType } from '@/constants/enums'
import { getScreeningInterviewAuthPayload } from '@/utils/screening-interview-auth.util'

const PROCTORING_ENDPOINT = '/api/interviews/screeningInterview/proctoring'

export function useProctoringEvents() {
    const { addEvent, flushEvents } = useBeaconEvents<ProctoringEventType>({
        endpoint: PROCTORING_ENDPOINT,
        getAuthPayload: getScreeningInterviewAuthPayload,
    })
    return { addProctoringEvent: addEvent, flushProctoringEvents: flushEvents }
}
